export default __webpack_public_path__ + "static/media/solution.455ef9c8.jpg";